import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {GrCity, GrUser} from '../../../../../interfaces/general-interfaces';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {EmailRegex, MobileRegex, PhoneRegex} from '../../../../../constants/general-variables';
import {UsersHttpService} from '../../../../../services/http-services/users/users-http.service';
import {ToastrService} from 'ngx-toastr';
import {GeneralHttpService} from '../../../../../services/http-services/general/general-http.service';
import {GetCitiesApiData} from '../../../../../services/http-services/general/general-http-interfaces';

@Component({
  selector: 'gr-edit-user-modal',
  templateUrl: './edit-user-modal.component.html'
})
export class EditUserModalComponent implements OnInit{
  @Input() userForEdit!: GrUser;
  @Output() closeModal: EventEmitter<void> = new EventEmitter<void>();
  @Output() confirmModal: EventEmitter<void> = new EventEmitter<void>();
  editUserForm!: FormGroup;
  formTriedToSubmit = false;
  isSelectCityDropdownOpen = false;
  cityList: GrCity[] = [];

  constructor(private formBuilder: FormBuilder,
              private toastService: ToastrService,
              private generalHttpService: GeneralHttpService,
              private usersHttpService: UsersHttpService) {
  }

  ngOnInit(): void {
    this.buildForm();
    this.getCities();
  }
  getCities(): void {
    this.generalHttpService.getCities().then((res: GetCitiesApiData) => {
      this.cityList = res.data;
    });
  }

  buildForm(): void {
    this.editUserForm = this.formBuilder.group({
      first_name: ['', Validators.required],
      last_name: ['', Validators.required],
      email: ['', [Validators.required, Validators.pattern(EmailRegex)]],
      phone: ['', [Validators.required, Validators.pattern(MobileRegex)]],
      postal_code: ['', Validators.required],
      address: ['', Validators.required],
      city_id: ['', Validators.required],
    });
    this.editUserForm.patchValue(this.userForEdit);
  }

  submitEditUserForm(): void {
    this.formTriedToSubmit = true;
    if (this.editUserForm.valid) {
      this.usersHttpService.putUser({userId: this.userForEdit.id}, this.editUserForm.value).then(res => {
        this.confirmModal.emit();
        this.toastService.success(res.message);
      }).catch(({error}: {error:{ errors: { [key: string]: string } }}) => {
        Object.values(error.errors).forEach(error => this.toastService.error(error));
      })
    }
  }
}

